import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function MemberDashboard({ data }) {
  return <Container className="dashboard p-4">
  <Row>
    <Col md={8}>
        <h2>Bienvenido</h2>
        <Row>
          {data.map((card, idx) => {
            return <Col md={6} key={'card-' + idx}>
              <Card>
                <Card.Header>{card.title}</Card.Header>
                <Card.Body>{card.content}</Card.Body>
                <Card.Footer>{card.footer}</Card.Footer>
              </Card>
            </Col>
          })}
        </Row>
    </Col>
    <Col md={4}>
      <Card>
        <Card.Header>Acciones</Card.Header>
        <Card.Body><Link to={'/app/user'}>Editar mi perfil</Link></Card.Body>
      </Card>
    </Col>
  </Row>
</Container>
}

export default MemberDashboard;
